import moment from 'moment';
import { dateFromISOString } from './date.utilities';

export function pickProperties(object: object | any, ...props: string[]) {
  return Object.assign({}, ...props.map((prop) => ({ [prop]: object[prop] })));
}

export function cleanNullProperties<T>(obj: T | any): T {
  Object.keys(obj).forEach((key) => {
    if (obj.hasOwnProperty(key)) {
      if (obj[key] == null) {
        delete obj[key];
      } else if (obj[key] instanceof Object) {
        obj[key] = cleanNullProperties(obj[key]);
      }
    }
  });
  return <T>obj;
}

export function equalsPropertyWithNullCheck(
  object1: object | any,
  object2: object | any,
  property: string,
) {
  if (object1 == null || object2 == null) {
    return false;
  }

  if (!object1.hasOwnProperty(property) || !object2.hasOwnProperty(property)) {
    return false;
  }

  return object1[property] === object2[property];
}

export const simpleEquals = (object1: object, object2: object): boolean => {
  if (
    (object1 == null && object2 != null) ||
    (object1 != null && object2 == null)
  ) {
    return false;
  }

  const keys1 = Object.keys(object1);
  const keys2 = Object.keys(object2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  return Object.keys(object1)
    .map((r) => equalsPropertyWithNullCheck(object1, object2, r))
    .every((b) => b);
};

export function objectToArray(o: any): any[] {
  return Object.keys(o)
    .filter((key) => o.hasOwnProperty(key))
    .map((key) => o[key]);
}

export const objectParseDates = <T, T2>(api: T | any): T2 => {
  if (api === undefined || api === null) return api as any;

  if (api instanceof Object) {
    if (Array.isArray(api)) {
      return [...api.map((x) => objectParseDates(x))] as any;
    } else {
      let front: any = {};

      Object.keys(api)
        .filter((key) => api.hasOwnProperty(key))
        .forEach((key) => {
          front[key] = objectParseDates(api[key]);
        });

      return front as T2;
    }
  } else if (
    !!api &&
    typeof api === 'string' &&
    moment(api, [moment.ISO_8601], true).isValid()
  ) {
    return dateFromISOString(api) as any;
  } else {
    return api as any;
  }
};
